
import * as AllGames from "../index.js"; // this gives you access to BinaryTreeIntroduction, etc.

export const getGraphGame = (subcategory, stage) => {
    if (subcategory === "Directed") {
        switch (stage.name.toLowerCase()) {
            case "introduction":
                return <AllGames.DirectedGameIntro />;
            case "searching":
                return <AllGames.SearchingDirected />;
            case "insertion-deletion":
                return <AllGames.InsertionDeletionDirected />;
            case "other categories":
                return <AllGames.OtherCategoriesDirected />;
            default:
                return <p style={{ color: "black" }}>Παιχνίδι δεν βρέθηκε.</p>;
        }
    }
    else if (subcategory === "Undirected") {
        switch (stage.name.toLowerCase()) {
            case "mst":
                return <AllGames.UndirectedMST />;
            case "introduction":
                return <AllGames.IntroUndirected />;
            case "insertion-deletion-searching":
                return <AllGames.InDelSeaUndirected />;
        }
    }

    return <p style={{ color: "black" }}>Δεν υποστηρίζεται αυτό το δέντρο.</p>;
};
